import { FC, useState } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { BottomMenu, CompanyLogo, TopMenu } from 'dashboard409a/components';
import {
  Bottom,
  CloseButtonContainer,
  CompanyLogoContainer,
  DrawerBottom,
  DrawerContainer,
  StyledCloseButton,
  StyledDrawer,
} from './styles';
import { ISidebar } from './types';


const Sidebar: FC<ISidebar> = props => {
  const { className = '', homePath = '/', topMenuItems, bottomMenuItems, logoUrl = '', isLoading } = props;
  const [isOpen, setIsOpen] = useState(true);

  // TODO: Toggle sidebar with Redux
  const handleLeave = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <StyledDrawer
      anchor="left"
      onClose={handleLeave}
      open={isOpen}
      variant="permanent"
      $isOpen={isOpen}
      PaperProps={{
        elevation: 0,
      }}>
      <DrawerContainer className={className}>
        {/* Close Button */}
        <CloseButtonContainer>
          <StyledCloseButton size="medium" onClick={handleLeave}>
            <CloseIcon />
          </StyledCloseButton>
        </CloseButtonContainer>

        {/* Firm logo */}
        <CompanyLogoContainer>
          <Link to={homePath || '#'}>
            <CompanyLogo logoUrl={logoUrl} />
          </Link>
        </CompanyLogoContainer>

        <DrawerBottom>
          <TopMenu items={topMenuItems} />

          <Bottom>
            <BottomMenu items={bottomMenuItems} isLoading={isLoading} />
          </Bottom>
        </DrawerBottom>
      </DrawerContainer>
    </StyledDrawer>
  );
};

export default Sidebar;